import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useBridge } from './useBridge';

/**
 * Mirrors the flow's intra-flow route into the host URL bar by emitting
 * `route:change` on every navigation (including the first).
 *
 * `useLocation().pathname` is already stripped of the router basename
 * (`/flows`), so it looks like `/card-payment-sca/approve-payment/abc`. We drop
 * the leading `/<flowId>` segment and hand the host the flow-relative path
 * (`approve-payment/abc`); the host rebuilds its own `/flow/<flowId>/<path>`.
 *
 * Use this in master→detail flows (plain `<Routes>`), where the URL carries a
 * param the linear StepWizard's `step:change` can't express. StepWizard flows
 * can adopt it too if they want shareable per-step URLs.
 */
export const useRouteSync = (flowId: string): void => {
  const bridge = useBridge();
  const { pathname } = useLocation();

  useEffect(() => {
    const prefix = `/${flowId}`;
    const rel = (pathname.startsWith(prefix) ? pathname.slice(prefix.length) : pathname).replace(
      /^\/+/,
      '',
    );
    bridge.emit({ type: 'route:change', flowId, path: rel });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);
};
